import React, { useEffect } from 'react';
import clsx from 'clsx';
import colors from "../../utils/colors";
import { NavigationClose } from "../../icons";

import { createStyles } from "./styles";

var Modal = function Modal(props) {
  var show = props.show,onClose = props.onClose,_props$closable = props.closable,closable = _props$closable === void 0 ? true : _props$closable,children = props.children,className = props.className;
  var classes = createStyles(props);

  var closeClickHandler = function closeClickHandler(e) {
    var target = e.target;
    if (closable && target.dataset.action === 'close-modal') {
      onClose(e);
    }
  };

  var keyPressHandler = function keyPressHandler(e) {
    if (closable && e.keyCode === 27) {
      onClose(e);
    }
  };

  useEffect(function () {
    document.addEventListener('keydown', keyPressHandler);
    return function () {
      document.removeEventListener('keydown', keyPressHandler);
    };
  }, []);
  return /*#__PURE__*/(
    React.createElement("div", {
      className: clsx(show ? classes.show : classes.hide, classes.backdrop),
      onClick: closeClickHandler,
      onKeyDown: keyPressHandler,
      role: "button",
      tabIndex: 0,
      "data-action": "close-modal",
      id: "backdrop" }, /*#__PURE__*/

    React.createElement("div", { className: clsx(classes.modal, className), ref: props.modalContainerRef },
    closable && /*#__PURE__*/
    React.createElement("div", {
      className: classes.iconWrapper,
      onClick: closeClickHandler,
      onKeyDown: keyPressHandler,
      role: "button",
      tabIndex: 0,
      "data-action": "close-modal",
      id: "close-icon" }, /*#__PURE__*/

    React.createElement(NavigationClose, { color: colors.neutral[500], className: classes.closeIcon })), /*#__PURE__*/



    React.createElement("div", { className: classes.modalContent, id: "modal-content-".concat(props.id) },
    children))));




};
Modal.displayName = 'Modal';
export default Modal;
//# sourceMappingURL=index.js.map